<template>
  <WmDrawer :visible="visible" v-if="visible" :title="info.originalFilename" :width='612'
            :extraStyle="{padding: '16px'}"
            @close="handleCancel">
    <file-preview :visible="visible" :info="info" :content="content" v-model="encodeType"
                  :loading="loading" :mode="previewMode"/>
  </WmDrawer>
</template>

<script>
import filePreview from '../../../../components/FileTable/filePreview.vue'

export default {
  name: 'FileDetail',
  components: {
    filePreview
  },
  props: {
    visible: { // 是否展示
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
    content: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    previewEncode: { // 编码格式
      type: String,
      default: 'UTF-8'
    },
    previewMode: { // 预览的文件格式
      type: String,
      default: 'UTF-8'
    }
  },
  data () {
    return {
      encodeType: 'UTF-8',
      encodingTypes: ['ANSI', 'UTF-16 LE', 'UTF-16 BE', 'UTF-8', 'GBK', 'Big5', ' Shift-JIS']
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.encodeType = this.previewEncode
        }
      },
      immediate: true
    },
    info: {
      handler (val) {
        if (val.originalFilename) {
          this.encodeType = this.previewEncode
        }
      },
      deep: true
    },
    encodeType (val) {
      this.changeEncode(val)
    }
  },
  methods: {
    // 关闭弹出
    handleCancel () {
      this.$emit('close')
    },
    changeEncode (val) {
      this.$emit('changeEncode', val)
    }
  }
}
</script>

<style scoped lang="less">
  .card-container {
    overflow: auto;
    height: calc(100vh - 219px);
    position: relative;

    .spin-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .txt-title {
    width: 496px;
    margin: 16px auto;
    display: flex;

    .title-label {
      color: rgba(0, 0, 0, 0.85);
    }

    .title-value {
      color: rgba(0, 0, 0, 0.65);
    }
  }

  .txt-content {
    width: 496px;
    margin: 16px auto;
    height: calc(100% - 69px - 48px);
    background-color: #f5f5f5;
    border-radius: 2px;
    border: solid 1px rgba(0, 0, 0, 0.15);
    padding: 8px;
    display: block;
    resize: none;
  }

  .ant-drawer-title {
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
